/** Unit price before add-ons for cart / checkout */
export function unitPriceForProduct(product, variantKey) {
  if (!product) return 0;
  const base = typeof product.priceNum === 'number' ? product.priceNum : parseFloat(product.price) || 0;
  if (variantKey && product.variants?.length) {
    const v = product.variants.find((x) => x.id === variantKey);
    if (v != null && v.price != null) {
      const p = parseFloat(v.price);
      if (Number.isFinite(p)) return p;
    }
  }
  return base;
}

/** Minimum list price for sorting (variants or base). */
export function minListPrice(product) {
  if (!product) return 0;
  if (product.variants?.length) {
    const nums = product.variants.map((v) => parseFloat(v.price)).filter((n) => Number.isFinite(n));
    if (nums.length) return Math.min(...nums);
  }
  const base = typeof product.priceNum === 'number' ? product.priceNum : parseFloat(product.price);
  return Number.isFinite(base) ? base : 0;
}

/** Shop card / listing */
export function shopPriceLabel(product) {
  if (!product) return '';
  if (product.variants?.length) {
    const nums = product.variants.map((v) => parseFloat(v.price)).filter((n) => Number.isFinite(n));
    if (nums.length) {
      const min = Math.min(...nums);
      const max = Math.max(...nums);
      if (min === max) return `$${min.toFixed(2)}`;
      return `From $${min.toFixed(2)}`;
    }
  }
  return product.price;
}

/** Detail page main price line */
export function detailPriceLabel(product, variantKey) {
  if (!product) return '';
  const u = unitPriceForProduct(product, variantKey);
  return `$${u.toFixed(2)}`;
}

/** Line total including add-ons × quantity */
export function lineItemSubtotal(item) {
  if (!item?.product) return 0;
  let addOnTotal = 0;
  if (item.add_ons) {
    try {
      const parsed = typeof item.add_ons === 'string' ? JSON.parse(item.add_ons) : item.add_ons;
      if (parsed) for (const ao of parsed) addOnTotal += ao.priceNum || 0;
    } catch {
      /* ignore */
    }
  }
  const unit = unitPriceForProduct(item.product, item.variant_key);
  return (unit + addOnTotal) * item.quantity;
}
